import { FC } from 'react';
import { StatusEnum } from 'data/enums';
import { assertUnreachable } from 'src/util';

import { Pill } from 'components/Pill';

type StatusPillProps = {
  status: StatusEnum;
};

export const StatusPill: FC<StatusPillProps> = ({ status }) => {
  switch (status) {
    case StatusEnum.SUCCESS:
      return <Pill text="Success" color="green" />;
    case StatusEnum.FAILURE:
      return <Pill text="Failure" color="red" />;
    case StatusEnum.IN_PROGRESS:
      return <Pill text="In Progress" color="gray" />;
    case StatusEnum.UNKNOWN:
      return <Pill text="Unknown" color="gray" />;
    default:
      assertUnreachable(status);
      return null;
  }
};
